import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, notFound, useRouter } from "@tanstack/react-router"
import { useEffect } from "react"

import { PagePanel } from "@repo/ui/components/ui/page-panel"
import { getExtendedBusinessEntitiesQueryOptions } from "~/modules/business-entities/business-entities.queries"
import { useFeatureConfigs } from "~/modules/system-config/hooks/use-feature-configs"

export const Route = createFileRoute(
  "/_protected-layout/_os-layout/business-entities/",
)({
  component: RouteComponent,
  loader: async ({ context }) => {
    context.queryClient.ensureQueryData(
      getExtendedBusinessEntitiesQueryOptions(),
    )
  },
})

function RouteComponent() {
  const router = useRouter()
  const { isBusinessEntityManagementOn } = useFeatureConfigs()

  if (!isBusinessEntityManagementOn) {
    throw notFound()
  }

  const { data: businessEntitiesData } = useSuspenseQuery(
    getExtendedBusinessEntitiesQueryOptions(),
  )

  // Auto-redirect to first business entity's overview if entities exist
  useEffect(() => {
    if (
      businessEntitiesData?.businessEntities &&
      businessEntitiesData.businessEntities.length > 0
    ) {
      const firstEntity = businessEntitiesData.businessEntities[0]
      router.navigate({
        to: "/business-entities/$businessEntitySlug/overview",
        params: { businessEntitySlug: firstEntity.slug },
        replace: true,
      })
    }
  }, [businessEntitiesData, router])

  // Show empty state if no business entities
  if (
    !businessEntitiesData?.businessEntities ||
    businessEntitiesData.businessEntities.length === 0
  ) {
    return (
      <PagePanel title="Business Entities">
        <div className="flex h-full flex-col items-center justify-center gap-4 text-center">
          <p className="text-white/70">
            No business entities found. Create your first business entity to get
            started.
          </p>
        </div>
      </PagePanel>
    )
  }

  // Loading state while redirecting
  return (
    <PagePanel title="Business Entities">
      <div className="flex h-full items-center justify-center">
        <p className="text-white/70">Loading...</p>
      </div>
    </PagePanel>
  )
}
